var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoMemberFields = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 9c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-3.314 2.69-6 6-6s6 2.686 6 6Zm0 33c0 1.66-1.34 3-3 3h-6c-1.66 0-3-1.34-3-3v-4.013c-3.544-1.687-6-5.296-6-9.487C18 22.697 22.697 18 28.5 18h3C37.303 18 42 22.697 42 28.5c0 4.19-2.456 7.8-6 9.487V42ZM24 24.534a5.94 5.94 0 0 0-1.5 3.966 5.94 5.94 0 0 0 1.5 3.966v-7.932ZM37.5 28.5c0-1.519-.647-2.916-1.5-3.966v7.932c.853-1.06 1.5-2.447 1.5-3.966Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6 9a6 6 0 1 1 12 0A6 6 0 0 1 6 9Zm12 27.984V42c0 1.66-1.34 3-3 3H9c-1.657 0-3-1.34-3-3v-4.013A10.498 10.498 0 0 1 0 28.5C0 22.697 4.7 18 10.5 18h3c1.847 0 3.59.478 5.1 1.322A13.467 13.467 0 0 0 15 28.5c0 3.216 1.04 6.169 3 8.484ZM6 32.466v-7.932A5.959 5.959 0 0 0 4.5 28.5c0 1.519.566 2.916 1.5 3.966Zm36 4.518c1.875-2.315 3-5.268 3-8.484 0-3.544-1.369-6.769-3.6-9.178A10.43 10.43 0 0 1 46.5 18h3C55.303 18 60 22.697 60 28.5c0 4.19-2.456 7.8-6 9.487V42c0 1.66-1.34 3-3 3h-6c-1.66 0-3-1.34-3-3v-5.016ZM55.5 28.5c0-1.519-.647-2.916-1.5-3.966v7.932c.853-1.06 1.5-2.447 1.5-3.966ZM42 9c0-3.314 2.69-6 6-6s6 2.686 6 6c0 3.31-2.69 6-6 6s-6-2.69-6-6Z",
    fill: "url(#b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30,
    y1: 3,
    x2: 30,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30,
    y1: 3,
    x2: 30,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AA0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoMemberFields);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-member-fields.b70f69d2234c1f637186cc5e424e5330.svg";